module.exports = __webpack_public_path__ + "images/ui-bg_highlight-soft_100_eeeeee_1x100.png";